import {Container} from "../../components/LayoutHelpers";
import {LogoMarquee} from "../../components/LogoMarquee/LogoMarquee";
import React from "react";
import "./LogosSection.css"

export default function LogosSection() {
    return <section aria-label="Integraciones">
        <Container className="logos">
            <h1>Vamos a tu stack y lo optimizamos</h1>
            <LogoMarquee speed={28}/>
        </Container>
    </section>
}